const SCHEDULABLE_STATUSES = new Set(["approved", "scheduled"]);
const APPROVABLE_STATUSES = new Set(["draft", "needs_review"]);

const WORKFLOW_COPY = {
  draft: {
    handoffTitle: "Draft in progress",
    handoffCopy: "Finish editing, then approve this post before it can move onto the calendar.",
    scheduleLabel: "Approve to schedule",
  },
  needs_review: {
    handoffTitle: "Needs approval",
    handoffCopy: "Review the copy, make any edits, then approve it before scheduling.",
    scheduleLabel: "Approve to schedule",
  },
  approved: {
    handoffTitle: "Approved asset",
    handoffCopy: "This post is approved and ready for scheduling, copy, or publishing workflow.",
    scheduleLabel: "Schedule",
  },
  scheduled: {
    handoffTitle: "Scheduled asset",
    handoffCopy: "This post is queued on the calendar and remains editable until publishing.",
    scheduleLabel: "Reschedule",
  },
  published: {
    handoffTitle: "Published asset",
    handoffCopy: "This post has moved through the workflow and is recorded as published.",
    scheduleLabel: "Published",
  },
  archived: {
    handoffTitle: "Archived asset",
    handoffCopy: "This post is archived. Restore or duplicate it before moving it forward.",
    scheduleLabel: "Archived",
  },
};

export function getAssetReviewWorkflow(asset = {}) {
  const status = asset.status || "draft";
  const copy = WORKFLOW_COPY[status] || WORKFLOW_COPY.draft;

  return {
    status,
    canApprove: APPROVABLE_STATUSES.has(status),
    canSchedule: SCHEDULABLE_STATUSES.has(status),
    canReschedule: status === "scheduled",
    isPublished: status === "published",
    isArchived: status === "archived",
    handoffTitle: copy.handoffTitle,
    handoffCopy: copy.handoffCopy,
    scheduleLabel: copy.scheduleLabel,
  };
}

export function getBulkSchedulePlan(assets = []) {
  const eligible = [];
  const blocked = [];

  assets.forEach((asset) => {
    if (!asset?.id) return;
    if (getAssetReviewWorkflow(asset).canSchedule) eligible.push(asset);
    else blocked.push(asset);
  });

  return {
    eligible,
    blocked,
    eligibleIds: eligible.map((asset) => asset.id),
    blockedIds: blocked.map((asset) => asset.id),
    canSchedule: eligible.length > 0,
    skippedCount: blocked.length,
  };
}
